export default __webpack_public_path__ + "static/media/Pross02.8707c540.jpg";